import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { SelfServeNodeLevels } from "../types";
import { buildNodeLevelPropName } from "../utils/buildNodeLevelPropName";
import { getSelectedNodesFromLocalStorage } from "../utils/localStorage";
import { useSelfServeContextStore } from "./SelfServeContext";
import { useNodesFromLocalStorage } from "./useNodesFromLocalStorage";
export var useSelectedNode = function useSelectedNode() {
  var nodesListFromContextStore = useNodesListFromContextStore();
  var nodesFromStorage = useNodesFromLocalStorage(getSelectedNodesFromLocalStorage());
  var selectedNodes = {};
  var _iterator = _createForOfIteratorHelper(SelfServeNodeLevels),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var level = _step.value;
      var nodeLevelProp = buildNodeLevelPropName(level);
      var levelIndex = level - 1;
      if (nodesListFromContextStore[levelIndex]) {
        selectedNodes[nodeLevelProp] = nodesListFromContextStore[levelIndex];
      } else if (nodesFromStorage) {
        selectedNodes[nodeLevelProp] = nodesFromStorage[level];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return selectedNodes;
};
var useNodesListFromContextStore = function useNodesListFromContextStore() {
  var _useSelfServeContextS = useSelfServeContextStore(["level1Node", "level2Node", "level3Node", "level4Node", "level5Node"]),
    _useSelfServeContextS2 = _slicedToArray(_useSelfServeContextS, 1),
    _useSelfServeContextS3 = _useSelfServeContextS2[0],
    level1Node = _useSelfServeContextS3.level1Node,
    level2Node = _useSelfServeContextS3.level2Node,
    level3Node = _useSelfServeContextS3.level3Node,
    level4Node = _useSelfServeContextS3.level4Node,
    level5Node = _useSelfServeContextS3.level5Node;
  return [level1Node, level2Node, level3Node, level4Node, level5Node];
};